import request from "./request";
import { RequestError } from "@/utils/errors";

const agent = {
  service() {
    return {
      get(id) {
        return request.get(`/agents-api/agents/${id}`, null);
      },
      patch(id, agent) {
        return request.patch(`/agents-api/agents/${id}`, agent, null);
      },
      enroll(agent) {
        return request.post(`/agents-api/agents/enrollment`, agent, null);
      },
      list(params) {
        params.pageIndex = params.pageIndex ? params.pageIndex : 0;
        params.pageSize = params.pageSize ? params.pageSize : 10;
        params.sort = params.sort ? params.sort : "name.last,ASC";

        return request
          .get("/agents-api/agents", params)
          .then((resp) => {
            return {
              resp: resp,
              filter: params.name ? params.name : "",
            };
          })
          .catch((e) => {
            throw e;
          });
      },
      email(data, params) {
        return request.post(`/agents-api/email`, data, params);
      },
      getAssignments(params) {
        return request.get("/interviews-api/agentAssignments", params);
      },
      getInvitationsStats(agentIds, params) {
        return request.get(
          `/interviews-api/agentInvitations/stats/%5B${agentIds}%5D/`,
          params,
        );
      },
      resendInvite(phone) {
        return request.get(`/users-api/users/resendInvite/${phone}`, null);
      },
      getReferrals(agentId, params) {
        return request.get(`/agents-api/agents/${agentId}/referrals`, params);
      },
      getReferral(agentId, referralId) {
        return request.get(
          `/agents-api/agents/${agentId}/referrals/${referralId}`,
          null,
        );
      },
      patchReferral(agentId, referralId, data) {
        return request.patch(
          `/agents-api/agents/${agentId}/referrals/${referralId}`,
          data,
          null,
          false,
        );
      },
      getReferralEvents(agentId, referralId, params) {
        return request.get(
          `/agents-api/agents/${agentId}/referrals/${referralId}/events`,
          params,
        );
      },
      postReferralNote(agentId, referralId, data) {
        return request.post(
          `/agents-api/agents/${agentId}/referrals/${referralId}/notes`,
          data,
        );
      },
      getAgentNotes(agentId, params) {
        return request.get(`/agents-api/agents/${agentId}/notes`, params);
      },
      postAgentNote(agentId, data) {
        return request.post(
          `/agents-api/agents/${agentId}/notes`,
          data,
          null,
          false,
        );
      },
      sendTestNotification(id) {
        return request.post(`/agents-api/notifications/sample`, {
          agentId: id,
        });
      },
      getNotifications(params) {
        return request.get(`/agents-api/notifications/mobile`, params);
      },
      getResponseTimeMetrics(id) {
        return request.get(`/agents-api/performanceMetrics/responseTime/${id}`);
      },
      potentialAgentInviteCode(code) {
        return request.get(
          `/agents-api/potentialAgents/invite/code/${code}`,
          null,
          false,
          false,
        );
      },
      declineInvitation(code) {
        return request.delete(
          `/agents-api/potentialAgents/invite/code/${code}`,
        );
      },
      patchPotentialAgentInviteCode(code, data) {
        return request.patch(
          `/agents-api/potentialAgents/invite/code/${code}`,
          data,
        );
      },
      getPotentialAgents(params) {
        return request.get(`/agents-api/potentialAgents`, params);
      },
      getPotentialAgentsSearch(params) {
        return request
          .get(`/agents-api/potentialAgents`, params)
          .then((resp) => {
            return {
              resp: resp,
              params: params,
            };
          })
          .catch((e) => {
            throw new RequestError(e, { resp: e.response, params: params });
          });
      },
      getPotentialAgent(id) {
        return request.get(`/agents-api/potentialAgents/${id}`);
      },
      postPotentialAgent(data) {
        return request
          .post(`/agents-api/potentialAgents`, data)
          .then((resp) => {
            return {
              resp: resp,
              agent: data,
            };
          })
          .catch((e) => {
            throw new RequestError(e, { resp: e.response, payload: data });
          });
      },
      patchPotentialAgent(id, data) {
        return request.patch(`/agents-api/potentialAgents/${id}`, data);
      },
      postPotentialAgentInvite(id) {
        return request.post(`/agents-api/potentialAgents/invite/${id}`);
      },
      deletePotentialAgent(id) {
        return request.delete(`/agents-api/potentialAgents/${id}`);
      },
      getAdminHoldReason(params) {
        return request.get(`/agents-api/adminHoldReasons`, params);
      },
      postAdminHoldReason(id, data, params) {
        return request.post(
          `/agents-api/agents/${id}/adminHoldReason`,
          data,
          params,
        );
      },
      deleteAdminHoldReason(id, rid) {
        return request.delete(
          `/agents-api/agents/${id}/adminHoldReason/${rid}`,
        );
      },
      getAgentLeaderboard(params) {
        return request.get(`/agents-api/agents/leaderboard`, params);
      },
      getAppVersion() {
        return request.get("/agents-api/appVersion", null);
      },
      delete(id) {
        return request.delete(`/agents-api/agents/${id}`);
      },
      reactivate(id) {
        return request.patch(`/agents-api/agents/${id}/reactivate`, null, null);
      },
      deleteCoverageArea(agentId, geoId) {
        return request.delete(
          `/agents-api/agents/${agentId}/coverageAreas/${geoId}`,
        );
      },
      postCoverageArea(agentId, data) {
        return request.post(
          `/agents-api/agents/${agentId}/coverageAreas`,
          data,
          null,
        );
      },
      postExcludedCoverageArea(agentId, geoId) {
        return request.post(
          `/agents-api/agents/${agentId}/excludedAreas/${geoId}`,
          null,
          null,
        );
      },
      deleteExcludedCoverageArea(agentId, geoId) {
        return request.delete(
          `/agents-api/agents/${agentId}/excludedAreas/${geoId}`,
          null,
          null,
        );
      },

      getMLSBoard(params) {
        return request.get(`/agents-api/mls-board`, params);
      },
    };
  },
};

export default agent;
